<div class="pxy-7">
  <mat-accordion>
    <mat-expansion-panel class="mt-7" hideToggle="true" #contractAccordion>
      <mat-expansion-panel-header
        (click)="exp_Accordion(contractAccordion.expanded)"
      >
        <mat-panel-title>
          <span class="svg-icon svg-icon-3x">
            <span [inlineSVG]="HospitalGroupIconPath"></span>
          </span>
          <h3 class="text-dark font-weight-bold ml-3">
            <span class="mr-3">Hospital Contract's</span>

            <br />
            <span class="text-muted font-weight-light font-size-sm"
              >Manage Hospital Contract's</span
            >
          </h3>
        </mat-panel-title>
        <mat-panel-description class="expansion_right">
          <button
            *ngIf="!contractAccordion.expanded"
            mat-icon-button
            class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
            color="primary"
          >
            <span class="material-icons"> keyboard_arrow_down </span>
          </button>

          <button
            *ngIf="contractAccordion.expanded"
            mat-icon-button
            class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
            color="primary"
          >
            <span class="material-icons"> keyboard_arrow_up </span>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="mt-6"></div>

      <ng-container>
        <mat-toolbar
          class="margin-top-0px"
          *ngIf="contractAccordion.expanded && isListContract"
          color="primary"
        >
          <mat-toolbar-row class="subheader">
            <form class="form col-xs-12 col-md-12">
              <div class="row">

                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <mat-form-field class="example-full-width">
                    <input
                      [matDatepicker]="fromdatepicker"
                      matInput
                      (click)="fromdatepicker.open()"
                      placeholder="From Date"
                      #fromdate
                      required
                      [(ngModel)]="from_date"
                      name="from_date"
                      autocomplete="off"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="fromdatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #fromdatepicker
                      disabled="false"
                      color="primary"
                      touchUi
                    ></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <mat-form-field class="example-full-width">
                    <input
                      [matDatepicker]="todatepicker"
                      matInput
                      (click)="todatepicker.open()"
                      placeholder="To Date"
                      #todate
                      ngModel
                      [min]="from_date"
                      [max]="maxdate"
                      required
                      name="to_date"
                      autocomplete="off"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="todatepicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #todatepicker
                      disabled="false"
                      color="primary"
                      touchUi
                    ></mat-datepicker>
                  </mat-form-field>
                </div>


                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <mat-form-field class="example-full-width">
                    <mat-label>Filter</mat-label>
                    <input
                      matInput
                      placeholder="Ex. school name,email,..."
                      [(ngModel)]="filterdata"
                      name="filterdata"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <button
                    (click)="applyFilter(filterdata, fromdate.value, todate.value)"
                    mat-icon-button
                    class="btn btn-primary my-3"
                  >
                    <mat-icon>search</mat-icon>
                  </button>

                  <!-- <span class="example-spacer"></span> -->

                </div>
              </div>
            </form>
          </mat-toolbar-row>
        </mat-toolbar>

        <div
          *ngIf="contractAccordion.expanded && isListContract"
          class="table-responsive"
        >
          <table
            mat-table
            [dataSource]="contractdataSource"
            class="mat-elevation-z1"
            matSort
            (matSortChange)="applySort($event)"
          >
            <!--- Note that these columns can be defined in any order.
                       The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="font-size-lg mb-0"
              >
                {{ i + 1 + Page_Size * (Page_Index - 1) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td
                mat-cell
                *matCellDef="let element"
                class="font-size-lg mb-0 text-capitalize"
              >
                {{ element.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="contract_details">
              <th mat-header-cell *matHeaderCellDef>Contract Periods</th>
              <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
                {{ element.contract_details.from_date | TimeDateFormat}} -
                {{ element.contract_details.to_date | TimeDateFormat }}
              </td>
            </ng-container>

            <ng-container matColumnDef="hospital">
              <th mat-header-cell *matHeaderCellDef>Hospital's</th>
              <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
                {{ element.hospital.name }}

              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
                <span *ngIf="element.contract_details.is_active == 1">Active</span>
                <span *ngIf="element.contract_details.is_active != 1">Inactive</span>

              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="textaligncenter">
                Actions
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="text-center">
                  <button
                    mat-icon-button
                    class="btn btn-sm btn-default btn-text-primary btn-icon mr-2"
                    color="primary"
                    (click)="showcreateContract('update', element.id)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-dfprimary">
                      <span [inlineSVG]="editicon"></span>
                    </span>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="contract_displayedColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: contract_displayedColumns"
            ></tr>
          </table>

          <ng-container *ngIf="contractdataSource.data.length < 1">
            <h4 class="text-center bg-white m-0">There is no data</h4>
          </ng-container>

          <mat-paginator
            [length]="totalLength"
            [pageSize]="Page_Size"
            [showFirstLastButtons]="true"
            [pageSizeOptions]="PageSize_Options"
            (page)="getContractList($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>


    </mat-expansion-panel>
  </mat-accordion>
</div>
